module.exports = __webpack_public_path__ + "static/img/order-detail-gif1.57030166.gif";